// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportsShifts_topRow__M5I7a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.ReportsShifts_titleBlock__6oF3X .ReportsShifts_title__fnEYG {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.ReportsShifts_titleBlock__6oF3X .ReportsShifts_subtitle__72VDB {
  margin: 4px 0 0;
  color: #666;
  font-size: 13px;
}

.ReportsShifts_actions__qpSt9 {
  display: flex;
  gap: 12px;
}

.ReportsShifts_downloadBtn__5wDAX {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #1d8752;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(29,135,82,0.18);
}

.ReportsShifts_downloadBtn__5wDAX svg { stroke: #fff; }

/* Cards */
.ReportsShifts_cards__YL4Lk {
  display: flex;
  gap: 20px;
  margin-bottom: 22px;
  flex-wrap: wrap;
}

.ReportsShifts_card__YOeyx {
  flex: 1 1;
  min-width: 240px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  padding: 16px;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.ReportsShifts_card__YOeyx:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

.ReportsShifts_cardHeader__kKh8N {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.ReportsShifts_cardIcon__d2xSf {
  font-size: 26px;
  opacity: 0.9;
}

.ReportsShifts_cardBody__mBd11 { font-size: 14px; color: #333; }

.ReportsShifts_row__7aZRV {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
}

.ReportsShifts_sep__fwqcS {
  height: 1px;
  background: #eef0f2;
  margin: 8px 0;
}

/* color accents */
.ReportsShifts_green__ZOg10 { border-top: 4px solid #2e7d32; }
.ReportsShifts_red__Hn2qT { border-top: 4px solid #c62828; }
.ReportsShifts_blue__fuMP1 { border-top: 4px solid #1565c0; }
.ReportsShifts_orange__37pzf { border-top: 4px solid #ff9800; }

.ReportsShifts_plus__tQYEE { color: #2e7d32; font-weight: 700; }
.ReportsShifts_minus__-qxzs { color: #c62828; font-weight: 700; }

/* Filters */
.ReportsShifts_filters__yhs9c {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.ReportsShifts_select__DojYl { min-width: 160px; }
.ReportsShifts_dateInput__yyBtx, .ReportsShifts_smallInput__n4HIk {
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #d0d6da;
  background: #fff;
  font-size: 14px;
}

/* Table wrapper & table (sticky header style) */
.ReportsShifts_tableWrapper__T6vpo {
  max-height: 40vh;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e6e9eb;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}

.ReportsShifts_table__F3SUw {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.ReportsShifts_table__F3SUw thead th {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #fafafa;
  padding: 12px 14px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e6e9eb;
}

.ReportsShifts_table__F3SUw th, .ReportsShifts_table__F3SUw td {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f3f5;
  text-align: left;
  vertical-align: middle;
}

.ReportsShifts_table__F3SUw tr:hover {
  background: #fbfbfb;
}

/* colored numbers */
.ReportsShifts_greenText__u-BIy { color: #2e7d32; font-weight: 700; }
.ReportsShifts_redText__TaTPd { color: #c62828; font-weight: 700; }

/* actions cell */
.ReportsShifts_actionCell__xTEuH {
  position: relative;
  width: 56px;
  text-align: right;
  padding-right: 18px;
}

.ReportsShifts_moreBtn__2Ps23 {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
}

.ReportsShifts_moreBtn__2Ps23:hover {
  background: #f0f0f0;
}

/* menu */
.ReportsShifts_menu__sg\\+nU {
  position: absolute;
  right: 8px;
  top: 34px;
  min-width: 170px;
  background: #fff;
  box-shadow: 0 8px 18px rgba(0,0,0,0.12);
  border-radius: 8px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 20;
}

.ReportsShifts_menuItem__FoW7d {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: #222;
  border-radius: 6px;
}

.ReportsShifts_menuItem__FoW7d:hover {
  background: #f7f7f8;
}

/* responsive tweaks */
@media (max-width: 980px) {
  .ReportsShifts_cards__YL4Lk { gap: 12px; }
  .ReportsShifts_card__YOeyx { padding: 14px; min-width: 200px; }
  .ReportsShifts_topRow__M5I7a { flex-direction: column; gap: 12px; align-items: flex-start; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ReportsPages/ReportsShifts.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,wCAAmB,YAAY,EAAE;;AAEjC,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,iCAAY,eAAe,EAAE,WAAW,EAAE;;AAE1C;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA,kBAAkB;AAClB,8BAAS,6BAA6B,EAAE;AACxC,4BAAO,6BAA6B,EAAE;AACtC,6BAAQ,6BAA6B,EAAE;AACvC,+BAAU,6BAA6B,EAAE;;AAEzC,6BAAQ,cAAc,EAAE,gBAAgB,EAAE;AAC1C,8BAAS,cAAc,EAAE,gBAAgB,EAAE;;AAE3C,YAAY;AACZ;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA,+BAAU,gBAAgB,EAAE;AAC5B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB,kCAAa,cAAc,EAAE,gBAAgB,EAAE;AAC/C,gCAAW,cAAc,EAAE,gBAAgB,EAAE;;AAE7C,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,8BAAS,SAAS,EAAE;EACpB,6BAAQ,aAAa,EAAE,gBAAgB,EAAE;EACzC,+BAAU,sBAAsB,EAAE,SAAS,EAAE,uBAAuB,EAAE;AACxE","sourcesContent":[".topRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.titleBlock .title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.titleBlock .subtitle {\n  margin: 4px 0 0;\n  color: #666;\n  font-size: 13px;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n}\n\n.downloadBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #1d8752;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  box-shadow: 0 2px 6px rgba(29,135,82,0.18);\n}\n\n.downloadBtn svg { stroke: #fff; }\n\n/* Cards */\n.cards {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 22px;\n  flex-wrap: wrap;\n}\n\n.card {\n  flex: 1;\n  min-width: 240px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n  padding: 16px;\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 18px rgba(0,0,0,0.08);\n}\n\n.cardHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.cardIcon {\n  font-size: 26px;\n  opacity: 0.9;\n}\n\n.cardBody { font-size: 14px; color: #333; }\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 0;\n}\n\n.sep {\n  height: 1px;\n  background: #eef0f2;\n  margin: 8px 0;\n}\n\n/* color accents */\n.green { border-top: 4px solid #2e7d32; }\n.red { border-top: 4px solid #c62828; }\n.blue { border-top: 4px solid #1565c0; }\n.orange { border-top: 4px solid #ff9800; }\n\n.plus { color: #2e7d32; font-weight: 700; }\n.minus { color: #c62828; font-weight: 700; }\n\n/* Filters */\n.filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.select { min-width: 160px; }\n.dateInput, .smallInput {\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #d0d6da;\n  background: #fff;\n  font-size: 14px;\n}\n\n/* Table wrapper & table (sticky header style) */\n.tableWrapper {\n  max-height: 40vh;\n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #e6e9eb;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 1px 6px rgba(0,0,0,0.04);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  background: #fafafa;\n  padding: 12px 14px;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 1px solid #e6e9eb;\n}\n\n.table th, .table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid #f1f3f5;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.table tr:hover {\n  background: #fbfbfb;\n}\n\n/* colored numbers */\n.greenText { color: #2e7d32; font-weight: 700; }\n.redText { color: #c62828; font-weight: 700; }\n\n/* actions cell */\n.actionCell {\n  position: relative;\n  width: 56px;\n  text-align: right;\n  padding-right: 18px;\n}\n\n.moreBtn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n}\n\n.moreBtn:hover {\n  background: #f0f0f0;\n}\n\n/* menu */\n.menu {\n  position: absolute;\n  right: 8px;\n  top: 34px;\n  min-width: 170px;\n  background: #fff;\n  box-shadow: 0 8px 18px rgba(0,0,0,0.12);\n  border-radius: 8px;\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  z-index: 20;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  background: transparent;\n  border: none;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  color: #222;\n  border-radius: 6px;\n}\n\n.menuItem:hover {\n  background: #f7f7f8;\n}\n\n/* responsive tweaks */\n@media (max-width: 980px) {\n  .cards { gap: 12px; }\n  .card { padding: 14px; min-width: 200px; }\n  .topRow { flex-direction: column; gap: 12px; align-items: flex-start; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topRow": `ReportsShifts_topRow__M5I7a`,
	"titleBlock": `ReportsShifts_titleBlock__6oF3X`,
	"title": `ReportsShifts_title__fnEYG`,
	"subtitle": `ReportsShifts_subtitle__72VDB`,
	"actions": `ReportsShifts_actions__qpSt9`,
	"downloadBtn": `ReportsShifts_downloadBtn__5wDAX`,
	"cards": `ReportsShifts_cards__YL4Lk`,
	"card": `ReportsShifts_card__YOeyx`,
	"cardHeader": `ReportsShifts_cardHeader__kKh8N`,
	"cardIcon": `ReportsShifts_cardIcon__d2xSf`,
	"cardBody": `ReportsShifts_cardBody__mBd11`,
	"row": `ReportsShifts_row__7aZRV`,
	"sep": `ReportsShifts_sep__fwqcS`,
	"green": `ReportsShifts_green__ZOg10`,
	"red": `ReportsShifts_red__Hn2qT`,
	"blue": `ReportsShifts_blue__fuMP1`,
	"orange": `ReportsShifts_orange__37pzf`,
	"plus": `ReportsShifts_plus__tQYEE`,
	"minus": `ReportsShifts_minus__-qxzs`,
	"filters": `ReportsShifts_filters__yhs9c`,
	"select": `ReportsShifts_select__DojYl`,
	"dateInput": `ReportsShifts_dateInput__yyBtx`,
	"smallInput": `ReportsShifts_smallInput__n4HIk`,
	"tableWrapper": `ReportsShifts_tableWrapper__T6vpo`,
	"table": `ReportsShifts_table__F3SUw`,
	"greenText": `ReportsShifts_greenText__u-BIy`,
	"redText": `ReportsShifts_redText__TaTPd`,
	"actionCell": `ReportsShifts_actionCell__xTEuH`,
	"moreBtn": `ReportsShifts_moreBtn__2Ps23`,
	"menu": `ReportsShifts_menu__sg+nU`,
	"menuItem": `ReportsShifts_menuItem__FoW7d`
};
export default ___CSS_LOADER_EXPORT___;
